/* Mostra o site no mercado/idioma do país do visitante (detetado pelo IP em cada visita). */
(function () {
  try {
    var cfg = window.cadrisGeo;
    if (!cfg) return;
    var KEY = 'cadrisGeoManual';
    var params = new URLSearchParams(location.search);
    var force = params.get('cadris_geo');
    if (!force && localStorage.getItem(KEY)) return;
    // escolha manual no seletor de país/idioma: respeitar e não voltar a mexer
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.action && e.target.action.indexOf('/localization') !== -1) {
        localStorage.setItem(KEY, '1');
      }
    }, true);

    var byCountry = { PT: 'pt-PT', DK: 'da', ES: 'es', FR: 'fr', BE: 'fr', LU: 'fr', DE: 'de', AT: 'de', IT: 'it' };

    var apply = function (country) {
      if (!country || cfg.countries.indexOf(country) === -1) return;
      var lang = byCountry[country] || 'en';
      if (cfg.languages.indexOf(lang) === -1) lang = cfg.languages.indexOf('en') !== -1 ? 'en' : cfg.language;
      if (country === cfg.country && lang === cfg.language) return;
      if (sessionStorage.getItem('cadrisGeoLast') === country + lang + location.pathname) return; // evita loops
      sessionStorage.setItem('cadrisGeoLast', country + lang + location.pathname);
      var form = document.createElement('form');
      form.method = 'post';
      form.action = cfg.url;
      var add = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); };
      add('form_type', 'localization');
      add('_method', 'put');
      add('utf8', '✓');
      add('country_code', country);
      add('language_code', lang);
      var path = location.pathname;
      if (cfg.rootUrl && cfg.rootUrl !== '/' && path.indexOf(cfg.rootUrl) === 0) path = path.slice(cfg.rootUrl.length) || '/';
      add('return_to', path + location.search.replace(/[?&]cadris_geo=[^&]*/, '').replace(/^&/, '?'));
      document.body.appendChild(form);
      form.submit();
    };

    if (force) { apply(force.toUpperCase()); return; }
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) { apply(j && j.detected_values && j.detected_values.country && j.detected_values.country.handle); })
      .catch(function () {});
  } catch (e) {}
})();
